module.exports = __webpack_public_path__ + "static/img/2.06cfda1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/2.png
// module id = ODv9
// module chunks = 1